<mat-icon [svgIcon]="exportItem.state.type | mpcmExportItemIconName" />
